import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pylon",
  "use": "icon-pylon-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" id=\"icon-pylon\">\n  <path fill=\"currentColor\" d=\"M7.675 10h4.65l-.45-1.5h-3.75l-.45 1.5zm3.975-2.25l-.9-3h-1.5l-.9 3h3.3zm2.85 4.5H13l-.45-1.5h-5.1L7 12.25H5.5l-1.5 3h12l-1.5-3z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol